import { render } from "./SummaryCourseStats.vue?vue&type=template&id=3ab353e0"
import script from "./SummaryCourseStats.vue?vue&type=script&lang=js"
export * from "./SummaryCourseStats.vue?vue&type=script&lang=js"

import exportComponent from "D:\\programmazione\\pronails\\MemsionPrivato\\front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__